// extracted by mini-css-extract-plugin
export default {"wall":"ObjectWallTab_wall__SgfdL","createButton":"ObjectWallTab_createButton__mf5NZ","postsList":"ObjectWallTab_postsList__iA9o8","emptyWall":"ObjectWallTab_emptyWall__blFjN"};